import { teamMembers } from "@/mocks/homeData";
import { useInView } from "@/hooks/useInView";

export default function TeamSection() {
  const { ref, inView } = useInView();

  return (
    <section id="about" ref={ref} className="relative py-20 md:py-28 px-4 md:px-6 bg-[#faf7f0]">
      <div className="max-w-7xl mx-auto">
        <div className={`flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-14 md:mb-20 ${inView ? "animate-in" : "opacity-0"}`}>
          <div className="max-w-xl">
            <p className="text-secondary-600 text-xs md:text-sm font-medium tracking-widest uppercase mb-4">
              / 关于我们
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              一群热爱技术
              <br />
              追求卓越的人
            </h2>
          </div>
          <div className="max-w-md">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              Tianyi 成立于 2018 年，从一间小小的工作室成长为拥有 80+ 技术专家的数字化服务团队。我们坚信，好的技术应该为人服务，而非反过来。
            </p>
          </div>
        </div>

        <div className={`flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-8 mb-14 md:mb-20 ${inView ? "animate-in animate-in-delay-1" : "opacity-0"}`}>
          <div className="flex items-center -space-x-3">
            {teamMembers.map((member) => (
              <div
                key={member.name}
                className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden border-2 border-[#faf7f0] ring-1 ring-foreground-200/30"
              >
                <img
                  src={member.avatar}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
          <div>
            <p className="text-foreground-700 text-sm md:text-base font-medium">
              {teamMembers.map((m) => m.name).join("、")}
            </p>
            <p className="text-foreground-400 text-xs md:text-sm mt-1">
              核心团队 · 来自 BAT 等一线互联网公司
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {teamMembers.map((member, idx) => (
            <div
              key={member.name}
              className={`bg-background-50 rounded-2xl p-5 md:p-6 hover:bg-background-100 transition-colors duration-200 ${
                inView ? `animate-in animate-in-delay-${idx + 1}` : "opacity-0"
              }`}
            >
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden mb-4 mx-auto">
                <img
                  src={member.avatar}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="font-heading text-foreground-900 font-bold text-base md:text-lg text-center">
                {member.name}
              </h3>
              <p className="text-foreground-400 text-xs md:text-sm text-center mt-1">
                {member.role}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}